/* eslint-disable import/prefer-default-export */
const fieldRegex = /%{(.+?)}/g;
export function extractFields(text) {
  const matches = text.match(fieldRegex) || [];

  // return only what's inside the %{}
  return matches.map(m => m.replace(fieldRegex, '$1'));
}
